import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NgZorroModule } from "src/app/ng-zorro.module";
import { LoaderFourHModule } from "src/app/shared/components/loader-4h/loader-4h.module";
import { LoginHeroModule } from "src/app/shared/components/login-hero/login-hero.module";
import { LoginShellComponent } from "./login-shell.component";

@NgModule({
  declarations: [LoginShellComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    NgZorroModule,
    LoaderFourHModule,
    LoginHeroModule,
  ],
  exports: [LoginShellComponent],
})
export class LoginShellModule {}
